// extracted by mini-css-extract-plugin
module.exports = {"articleLabel":"ArticleLabel_articleLabel__Tlhmd"};